import { supabase } from "../../lib/supabaseClient.ts";
import React, { useEffect, useState } from "react";
import { useParams, useNavigate, Link, Navigate } from "react-router-dom";
import { Modal, Button, Form } from "react-bootstrap";
import pawPrint from "../../assets/img/w_pawprint.png";


const ProductDetails = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [product, setProduct] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [updatingPromo, setUpdatingPromo] = useState(false);
  const [deleting, setDeleting] = useState(false);
  const [promoPercentage, setPromoPercentage] = useState("");
  const [showVariationsModal, setShowVariationsModal] = useState(false);
  const [editingVariation, setEditingVariation] = useState(null);
  const [variationForm, setVariationForm] = useState({
    name: "",
    price: "",
    weight: "",
    old_price: "",
    composition: "",
    analysis: "",
    ingredients: "",
    antioxidants: "",
    energy: "",
    image: "",
  });
  const [updatingVariationPromo, setUpdatingVariationPromo] = useState(false);
  const [showPromoPopup, setShowPromoPopup] = useState(false);
  const [currentVariation, setCurrentVariation] = useState(null);
  const [currentPromoType, setCurrentPromoType] = useState("percentage");
  const [promoInputValue, setPromoInputValue] = useState("");
  const [productPromoType, setProductPromoType] = useState(
    product?.promo_type || "percentage"
  );
  const [exactPromoPrice, setExactPromoPrice] = useState(
    product?.price_range || ""
  );
  const [variations, setVariations] = useState([]);
  const [showFormModal, setShowFormModal] = useState(false);
  const [uploading, setUploading] = useState(false);

  useEffect(() => {
    if (product) {
      setProductPromoType(product.promo_type || "percentage");
      setExactPromoPrice(
        product.price_range
          ? product.price_range.toString().replace(".", ",")
          : ""
      );
      setPromoPercentage(product.promo_percentage || 10);
    }
  }, [product]);

  const openPromoPopup = (variation, type) => {
    setCurrentVariation(variation);
    setCurrentPromoType(type);
    setPromoInputValue(
      type === "percentage" ? variation.promo_percentage || "10" : variation.price
    );
    setShowPromoPopup(true);
  };

  const submitPromoPopup = () => {
    if (!currentVariation) return;
    const normalizedValue = promoInputValue.toString().replace(",", ".");
    handleVariationPromoChange(currentVariation, currentPromoType, normalizedValue);
    setShowPromoPopup(false);
  };

  const handleProductPromoTypeChange = async (newType) => {
    try {
      let updateData = { promo_type: newType };
      const basePrice = product.old_price
        ? parseFloat(product.old_price)
        : parseFloat(product.price_range);

      if (newType === "percentage") {
        const percentage = product.promo_percentage || 10;
        const newPrice = basePrice * (1 - percentage / 100);
        updateData.price_range = newPrice;
        updateData.promo_percentage = percentage;
        if (!product.old_price) updateData.old_price = product.price_range;
      } else if (newType === "exact") {
        updateData.promo_percentage = null;
        if (!product.old_price) updateData.old_price = product.price_range;
      }

      const { data, error } = await supabase
        .from("products")
        .update(updateData)
        .eq("id", product.id)
        .select()
        .single();
      if (error) throw error;

      setProduct(data);
      setProductPromoType(newType);
      alert(`Type de promo changé en: ${newType === "percentage" ? "Pourcentage" : "Prix exact"}`);
    } catch (error) {
      console.error("Error changing promo type:", error);
      alert("Erreur lors du changement de type de promo");
    }
  };

  const handleProductExactPriceChange = async () => {
    const newPrice = parsePrice(exactPromoPrice);
    if (isNaN(newPrice) || newPrice <= 0) {
      alert("Veuillez entrer un prix valide");
      return;
    }
    try {
      const updateData = {
        price_range: newPrice,
        promo_type: "exact",
        promo_percentage: null,
      };
      if (!product.old_price) updateData.old_price = product.price_range;

      const { data, error } = await supabase
        .from("products")
        .update(updateData)
        .eq("id", product.id)
        .select()
        .single();
      if (error) throw error;

      setProduct(data);
      alert("Prix promo mis à jour avec succès");
    } catch (error) {
      console.error("Error updating exact price:", error);
      alert("Erreur lors de la mise à jour du prix");
    }
  };

  const formatPrice = (price) => {
    const num = parseFloat(
      price.toString().replace(/\s/g, "").replace(/[^\d.-]/g, "")
    );
    if (isNaN(num)) return price;
    return num.toLocaleString("fr-FR");
  };

  const parsePrice = (price) => {
    return parseFloat(
      price.toString().replace(/\s/g, "").replace(",", ".").replace(/[^\d.-]/g, "")
    );
  };

  const handleToggleVariationPromo = async (variation) => {
    setUpdatingVariationPromo(true);
    try {
      const updatedPromo = !variation.promo;
      if (updatedPromo) {
        const basePrice = variation.old_price
          ? parseFloat(variation.old_price)
          : parseFloat(variation.price);
        const defaultPercentage = 10;
        const newPrice = basePrice * (1 - defaultPercentage / 100);
        const updatePayload = {
          promo: true,
          promo_type: "percentage",
          promo_percentage: defaultPercentage,
          price: newPrice,
          old_price: basePrice,
        };
        const { error } = await supabase
          .from("product_variations")
          .update(updatePayload)
          .eq("id", variation.id);
        if (error) throw error;
        await refreshVariations(product.id);
        alert("Promo activée avec 10% de réduction par défaut.");
      } else {
        const originalPrice = variation.old_price
          ? parseFloat(variation.old_price)
          : parseFloat(variation.price);
        const updatePayload = {
          promo: false,
          promo_type: null,
          promo_percentage: null,
          price: originalPrice,
          old_price: null,
        };
        const { error } = await supabase
          .from("product_variations")
          .update(updatePayload)
          .eq("id", variation.id);
        if (error) throw error;
        await refreshVariations(product.id);
        alert("Promo retirée avec succès");
      }
    } catch (error) {
      console.error("Error toggling promo:", error.message);
      alert("Erreur lors de la mise à jour de la promo: " + error.message);
    } finally {
      setUpdatingVariationPromo(false);
    }
  };

  const handleVariationPromoChange = async (variation, promoType, value) => {
    try {
      let updateData = { promo: true, promo_type: promoType };
      if (promoType === "percentage") {
        const percentage = parsePrice(value);
        if (isNaN(percentage) || percentage < 0 || percentage > 100) {
          alert("Veuillez entrer un pourcentage valide entre 0 et 100");
          return;
        }
        const basePrice = variation.old_price
          ? parsePrice(variation.old_price)
          : parsePrice(variation.price);
        const newPrice = basePrice * (1 - percentage / 100);
        updateData.promo_percentage = percentage;
        updateData.price = parsePrice(newPrice);
        if (!variation.old_price) updateData.old_price = basePrice;
      } else if (promoType === "exact") {
        const exactPrice = parsePrice(value);
        if (isNaN(exactPrice) || exactPrice <= 0) {
          alert("Veuillez entrer un prix valide");
          return;
        }
        if (!variation.old_price) updateData.old_price = parsePrice(variation.price);
        updateData.price = parsePrice(exactPrice);
        updateData.promo_percentage = null;
      }
      const { error } = await supabase
        .from("product_variations")
        .update(updateData)
        .eq("id", variation.id);
      if (error) throw error;
      await refreshVariations(product.id);
      const typeLabel = promoType === "percentage" ? "pourcentage" : "prix exact";
      alert(`Promo ${typeLabel} mise à jour avec succès!`);
    } catch (error) {
      console.error("Error updating promo:", error);
      alert("Erreur lors de la mise à jour de la promo: " + error.message);
    }
  };

  const handleVariationPromoPercentageChange = async (variation, percentage) => {
    const numPercentage = parseFloat(percentage);
    if (isNaN(numPercentage) || numPercentage < 0 || numPercentage > 100) {
      alert("Veuillez entrer un pourcentage valide entre 0 et 100.");
      return;
    }
    try {
      const basePrice = variation.old_price
        ? parsePrice(variation.old_price)
        : parsePrice(variation.price);
      const calculatedPrice = variation.promo
        ? basePrice * (1 - numPercentage / 100)
        : basePrice;
      const { data, error } = await supabase
        .from("product_variations")
        .update({
          promo_percentage: numPercentage,
          price: parsePrice(calculatedPrice),
        })
        .eq("id", variation.id)
        .select()
        .single();
      if (error) throw error;
      await refreshVariations(product.id);
      alert("Pourcentage promo mis à jour avec succès");
    } catch (error) {
      console.error("Error updating promo percentage:", error.message);
      alert("Erreur lors de la mise à jour: " + error.message);
    }
  };

  const handleAddOrUpdateVariation = async () => {
    const { name, price, weight, old_price, composition, analysis, ingredients, antioxidants, energy, image } = variationForm;
    if (!name || !price || !weight) return alert("Champs obligatoires manquants.");
    const numericPrice = parsePrice(price);
    const numericOldPrice = old_price ? parsePrice(old_price) : null;
    const payload = {
      product_id: product.id,
      variation_name: name,
      price: numericPrice,
      weight,
      old_price: numericOldPrice,
      composition: composition || null,
      analysis: analysis || null,
      ingredients: ingredients || null,
      antioxidants: antioxidants || null,
      energy: energy || null,
      image: image || null,
    };
    try {
      const { error } = editingVariation
        ? await supabase.from("product_variations").update(payload).eq("id", editingVariation.id)
        : await supabase.from("product_variations").insert(payload);
      if (error) throw error;
      refreshVariations(product.id);
      setVariationForm({ name: "", price: "", weight: "", old_price: "", composition: "", analysis: "", ingredients: "", antioxidants: "", energy: "", image: "" });
      setEditingVariation(null);
      setShowFormModal(false);
    } catch (err) {
      console.error(err);
      alert("Erreur lors de la sauvegarde: " + err.message);
    }
  };

  const handleToggleAvailability = async (variation) => {
    try {
      const { error } = await supabase
        .from("product_variations")
        .update({ available: !variation.available })
        .eq("id", variation.id);
      if (error) throw error;
      refreshVariations(product.id);
    } catch (err) {
      console.error("Erreur lors du changement de disponibilité:", err.message);
      alert("Impossible de changer la disponibilité");
    }
  };

  const handleImageUpload = async (event) => {
    const file = event.target.files[0];
    if (!file) return;
    setUploading(true);
    const filePath = `animalia/${Date.now()}-${file.name}`;
    const { error } = await supabase.storage.from("animalia").upload(filePath, file);
    if (error) {
      alert("Erreur lors de l'upload: " + error.message);
      setUploading(false);
      return;
    }
    const { data: urlData } = supabase.storage.from("animalia").getPublicUrl(filePath);
    if (urlData?.publicUrl) {
      setVariationForm((prev) => ({ ...prev, image: urlData.publicUrl }));
    }
    setUploading(false);
  };

  useEffect(() => {
    async function fetchProduct() {
      try {
        const { data, error } = await supabase
          .from("products")
          .select("*")
          .eq("id", id)
          .single();
        if (error) throw error;
        if (data.image) {
          const filename = data.image.split("/").pop();
          const { data: urlData } = supabase.storage
            .from("animalia")
            .getPublicUrl(filename);
          data.image = urlData?.publicUrl || data.image;
        }
        setProduct(data);
        setPromoPercentage(data.promo_percentage || "");
        refreshVariations(data.id);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    }
    fetchProduct();
  }, [id]);

  const refreshVariations = async (productId) => {
    const { data, error } = await supabase
      .from("product_variations")
      .select("*")
      .eq("product_id", productId);
    if (!error) setVariations(data);
  };

  const handleEditClick = (variation) => {
    setEditingVariation(variation);
    setVariationForm({
      name: variation.variation_name,
      price: variation.price?.toString().replace(".", ","),           // ← fix
      weight: variation.weight,
      old_price: variation.old_price
        ? variation.old_price.toString().replace(".", ",")           // ← fix
        : "",
      composition: variation.composition || "",
      analysis: variation.analysis || "",
      ingredients: variation.ingredients || "",
      antioxidants: variation.antioxidants || "",
      energy: variation.energy || "",
      image: variation.image || "",
    });
    setShowFormModal(true);
  };

  const handleDeleteVariation = async (variation) => {
    if (!window.confirm("Supprimer cette variation ?")) return;
    const { error } = await supabase
      .from("product_variations")
      .delete()
      .eq("id", variation.id);
    if (!error) refreshVariations(product.id);
  };

  const handleTogglePromo = async () => {
    if (!product) return;
    setUpdatingPromo(true);
    try {
      const updatedPromo = !product.promo;
      if (updatedPromo) {
        const currentPrice = parseFloat(product.price_range);
        const percentage = promoPercentage || 10;
        const newPrice = currentPrice * (1 - percentage / 100);
        const updateData = {
          promo: true,
          promo_type: "percentage",
          promo_percentage: percentage,
          price_range: newPrice,
          old_price: currentPrice,
        };
        const { data, error } = await supabase
          .from("products")
          .update(updateData)
          .eq("id", product.id)
          .select()
          .single();
        if (error) throw error;
        setProduct(data);
        setPromoPercentage(data.promo_percentage || "");
        setProductPromoType("percentage");
        alert(`Promo activée avec ${percentage}% de réduction`);
      } else {
        const originalPrice = product.old_price
          ? parseFloat(product.old_price)
          : parseFloat(product.price_range);
        const updateData = {
          promo: false,
          promo_type: null,
          promo_percentage: null,
          price_range: originalPrice,
          old_price: null,
        };
        const { data, error } = await supabase
          .from("products")
          .update(updateData)
          .eq("id", product.id)
          .select()
          .single();
        if (error) throw error;
        setProduct(data);
        setPromoPercentage("");
        alert("Promo retirée avec succès. Prix d'origine restauré.");
      }
    } catch (error) {
      console.error("Error toggling promo:", error);
      alert("Erreur lors de la mise à jour de la promo: " + error.message);
    } finally {
      setUpdatingPromo(false);
    }
  };

  const handlePercentageChange = async () => {
    const percentage = parsePrice(promoPercentage);
    if (isNaN(percentage) || percentage < 0 || percentage > 100) {
      alert("Veuillez entrer un pourcentage valide entre 0 et 100.");
      return;
    }
    try {
      const basePrice = product.old_price
        ? parseFloat(product.old_price)
        : parseFloat(product.price_range);
      const newPrice = basePrice * (1 - percentage / 100);
      const updateData = {
        promo_percentage: percentage,
        price_range: newPrice,
        promo_type: "percentage",
      };
      if (!product.old_price) updateData.old_price = product.price_range;
      const { data, error } = await supabase
        .from("products")
        .update(updateData)
        .eq("id", product.id)
        .select()
        .single();
      if (error) throw error;
      setProduct(data);
      alert(`Pourcentage mis à jour. Nouveau prix: ${newPrice.toFixed(3)} DT`);
    } catch (error) {
      console.error("Error updating percentage:", error);
      alert("Erreur lors de la mise à jour: " + error.message);
    }
  };

  const handleDelete = async () => {
    if (!window.confirm("Êtes-vous sûr de vouloir supprimer ce produit ?")) return;
    setDeleting(true);
    const { error } = await supabase.from("products").delete().eq("id", id);
    if (!error) navigate("/admin/products");
    setDeleting(false);
  };

  if (loading) return <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "60vh" }}>Chargement...</div>;
  if (error) return <div className="container my-5 text-center text-danger">Erreur: {error}</div>;
  if (!product) return <div className="container my-5 text-center">Produit non trouvé</div>;

  return (
    <>
      {/* ── Scoped responsive styles ── */}
      <style>{`
        .pd-wrapper {
          min-height: 80vh;
          background-color: #f9f9f9;
          padding: 1rem;
        }
        .pd-card {
          background: #fff;
          border-radius: 16px;
          box-shadow: 0 4px 24px rgba(0,0,0,0.08);
          padding: 1.5rem;
          width: 100%;
          max-width: 960px;
          margin: 2rem auto;
        }
        .pd-top {
          display: flex;
          flex-direction: column;
          gap: 1.5rem;
          align-items: flex-start;
        }
        @media (min-width: 768px) {
          .pd-top {
            flex-direction: row;
            align-items: flex-start;
          }
        }
        .pd-image {
          width: 100%;
          max-width: 100%;
          height: auto;
          max-height: 260px;
          object-fit: contain;
          border-radius: 12px;
          flex-shrink: 0;
        }
        @media (min-width: 768px) {
          .pd-image {
            width: 220px;
            max-width: 220px;
          }
        }
        .pd-body {
          flex: 1;
          min-width: 0;
        }
        .pd-promo-box {
          background: linear-gradient(135deg, #fff5f8 0%, #ffe6f0 100%);
          padding: 1.25rem;
          border-radius: 16px;
          border: 2px solid #ffcce0;
          box-shadow: 0 4px 12px rgba(255,105,180,0.15);
          margin-bottom: 1.25rem;
        }
        .pd-promo-price-row {
          display: flex;
          align-items: center;
          gap: 1rem;
          flex-wrap: wrap;
        }
        .pd-promo-type-group {
          display: flex;
          flex-direction: column;
          gap: 0.5rem;
        }
        @media (min-width: 480px) {
          .pd-promo-type-group {
            flex-direction: row;
          }
        }
        .pd-promo-input-row {
          display: flex;
          flex-wrap: wrap;
          gap: 0.5rem;
          align-items: center;
        }
        .pd-info-box {
          background: #f9fafb;
          padding: 12px 16px;
          border-radius: 10px;
          border: 1px solid #eee;
          display: flex;
          flex-direction: column;
          gap: 6px;
        }
        .pd-action-bar {
          display: flex;
          flex-wrap: wrap;
          justify-content: space-between;
          align-items: center;
          gap: 0.75rem;
          margin-top: 1.25rem;
        }
        .pd-action-right {
          display: flex;
          flex-wrap: wrap;
          gap: 0.5rem;
        }
        .pd-pill-btn {
          display: inline-flex;
          align-items: center;
          gap: 6px;
          padding: 0.35rem 0.85rem;
          border-radius: 1rem;
          font-size: 0.875rem;
          line-height: 1.3;
          background-color: #ff41b4;
          color: #fff;
          border: none;
          cursor: pointer;
          white-space: nowrap;
        }
        .pd-pill-btn:disabled {
          opacity: 0.65;
          cursor: not-allowed;
        }
        /* Variation list */
        .pd-variation-item {
          padding: 0.75rem;
        }
        .pd-variation-inner {
          display: flex;
          flex-direction: column;
          gap: 0.75rem;
        }
        @media (min-width: 600px) {
          .pd-variation-inner {
            flex-direction: row;
            align-items: flex-start;
            justify-content: space-between;
          }
        }
        .pd-variation-btns {
          display: flex;
          flex-wrap: wrap;
          gap: 4px;
          align-items: center;
        }
        /* Popup overlay */
        .pd-popup-overlay {
          position: fixed;
          inset: 0;
          background: rgba(0,0,0,0.5);
          display: flex;
          justify-content: center;
          align-items: center;
          z-index: 1050;
          padding: 1rem;
        }
        .pd-popup-box {
          background: #fff;
          padding: 1.5rem;
          border-radius: 12px;
          width: 100%;
          max-width: 320px;
          text-align: center;
        }
        .pd-savings-chip {
          margin-left: auto;
          background-color: #d4edda;
          padding: 8px 16px;
          border-radius: 20px;
          border: 1px solid #c3e6cb;
        }
        @media (max-width: 480px) {
          .pd-savings-chip {
            margin-left: 0;
          }
        }
      `}</style>

      <div className="pd-wrapper">
        <div className="pd-card">
          <div className="pd-top">

            {/* ── Product image ── */}
            {product.image && (
              <img
                src={product.image}
                alt={product.name}
                className="pd-image"
              />
            )}

            {/* ── Product body ── */}
            <div className="pd-body">
              <h2 className="mb-3">{product.name}</h2>

              {/* ── Active promo panel ── */}
              {product.promo && (
                <div className="pd-promo-box">
                  {/* Badges */}
                  <div className="d-flex flex-wrap align-items-center gap-2 mb-3">
                    <span className="badge" style={{ fontSize: "0.9rem", padding: "6px 14px", background: "linear-gradient(135deg,#ff69b4,#ff1493)", color: "#fff", borderRadius: "20px" }}>
                      🎉 Promotion Active
                    </span>
                    {product.promo_type === "percentage" && product.promo_percentage && (
                      <span className="badge" style={{ fontSize: "0.85rem", padding: "5px 12px", backgroundColor: "#28a745", color: "#fff", borderRadius: "18px" }}>
                        -{product.promo_percentage}% de réduction
                      </span>
                    )}
                    {product.promo_type === "exact" && (
                      <span className="badge" style={{ fontSize: "0.85rem", padding: "5px 12px", backgroundColor: "#17a2b8", color: "#fff", borderRadius: "18px" }}>
                        Prix Spécial
                      </span>
                    )}
                  </div>

                  {/* Price display */}
                  <div className="mb-3 p-3" style={{ backgroundColor: "#fff", borderRadius: "12px", border: "1px solid #ffe0f0" }}>
                    <div className="pd-promo-price-row">
                      {product.old_price && (
                        <div>
                          <small style={{ color: "#999", fontSize: "0.8rem", display: "block" }}>Prix d'origine</small>
                          <div style={{ position: "relative", display: "inline-block" }}>
                            <span style={{ fontSize: "1.1rem", color: "#aaa", fontWeight: 600 }}>
                              {parseFloat(product.old_price).toLocaleString("fr-FR", { minimumFractionDigits: 3, maximumFractionDigits: 3 })} DT
                            </span>
                            <div style={{ position: "absolute", top: "50%", left: "-2px", right: "-2px", height: "2px", background: "linear-gradient(90deg,transparent,#ff4444,transparent)", transform: "translateY(-50%) rotate(-5deg)" }} />
                          </div>
                        </div>
                      )}
                      {product.old_price && <span style={{ fontSize: "1.5rem", color: "#28a745" }}>→</span>}
                      <div>
                        <small style={{ color: "#28a745", fontSize: "0.8rem", display: "block", fontWeight: 600 }}>Prix promotionnel</small>
                        <span style={{ fontSize: "1.6rem", background: "linear-gradient(135deg,#ff1493,#ff69b4)", WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent", fontWeight: 900 }}>
                          {parseFloat(product.price_range).toLocaleString("fr-FR", { minimumFractionDigits: 3, maximumFractionDigits: 3 })}
                          <span style={{ fontSize: "1rem", fontWeight: 700 }}> DT</span>
                        </span>
                      </div>
                      {product.old_price && product.promo_type === "percentage" && product.promo_percentage && (
                        <div className="pd-savings-chip">
                          <small style={{ color: "#155724", fontSize: "0.75rem", display: "block", fontWeight: 600 }}>Vous économisez</small>
                          <span style={{ color: "#28a745", fontWeight: 800, fontSize: "1rem" }}>
                            💰 {(parseFloat(product.old_price) - parseFloat(product.price_range)).toLocaleString("fr-FR", { minimumFractionDigits: 3, maximumFractionDigits: 3 })} DT
                          </span>
                        </div>
                      )}
                    </div>
                  </div>

                  {/* Promo type toggle */}
                  <div className="mb-3">
                    <label className="form-label" style={{ fontWeight: 600, color: "#333", fontSize: "0.9rem" }}>Type de promotion</label>
                    <div className="pd-promo-type-group">
                      <button
                        type="button"
                        className="btn"
                        style={{ backgroundColor: productPromoType === "percentage" ? "#007bff" : "#e9ecef", color: productPromoType === "percentage" ? "#fff" : "#6c757d", border: "2px solid " + (productPromoType === "percentage" ? "#007bff" : "#dee2e6"), fontWeight: 600 }}
                        onClick={() => handleProductPromoTypeChange("percentage")}
                      >
                        📊 Pourcentage {productPromoType === "percentage" && "✓"}
                      </button>
                      <button
                        type="button"
                        className="btn"
                        style={{ backgroundColor: productPromoType === "exact" ? "#28a745" : "#e9ecef", color: productPromoType === "exact" ? "#fff" : "#6c757d", border: "2px solid " + (productPromoType === "exact" ? "#28a745" : "#dee2e6"), fontWeight: 600 }}
                        onClick={() => handleProductPromoTypeChange("exact")}
                      >
                        💰 Prix Exact {productPromoType === "exact" && "✓"}
                      </button>
                    </div>
                  </div>

                  {/* Percentage input */}
                  {productPromoType === "percentage" && (
                    <div className="p-3" style={{ backgroundColor: "#f0f8ff", borderRadius: "10px", border: "1px solid #b3d9ff" }}>
                      <label className="form-label" style={{ fontWeight: 600, color: "#0056b3", fontSize: "0.9rem" }}>Pourcentage de réduction</label>
                      <div className="pd-promo-input-row">
                        <input
                          type="text"
                          inputMode="decimal"
                          className="form-control"
                          style={{ width: "120px", border: "2px solid #007bff", fontWeight: 600 }}
                          value={promoPercentage}
                          onChange={(e) => {
                            setPromoPercentage(e.target.value);
                          }}
                          min="0" max="100" placeholder="10"
                        />
                        <span style={{ fontWeight: 600, color: "#007bff" }}>%</span>
                        <button className="btn pd-pill-btn" style={{ borderRadius: "8px", fontSize: "0.85rem" }} onClick={handlePercentageChange}>
                          ✓ Appliquer le pourcentage
                        </button>
                      </div>
                      <small className="text-muted d-block mt-2">
                        Prix calculé: Prix d'origine × (1 - {exactPromoPrice || 0}%)

                      </small>
                    </div>
                  )}

                  {/* Exact price input */}
                  {productPromoType === "exact" && (
                    <div className="p-3" style={{ backgroundColor: "#f0fff4", borderRadius: "10px", border: "1px solid #9ae6b4" }}>
                      <label className="form-label" style={{ fontWeight: 600, color: "#22543d", fontSize: "0.9rem" }}>Prix promotionnel exact</label>
                      <div className="pd-promo-input-row">
                        <input
                          type="text"
                          inputMode="decimal"
                          className="form-control"
                          style={{ width: "150px", border: "2px solid #28a745", fontWeight: 600 }}
                          value={exactPromoPrice}
                          onChange={(e) => {
                            let val = e.target.value.replace(".", ",");
                            const parts = val.split(",");
                            if (parts.length > 2) val = parts[0] + "," + parts.slice(1).join("");
                            setExactPromoPrice(val);
                          }}
                          placeholder={product.price_range}
                        />
                        <button className="btn" style={{ backgroundColor: "#28a745", color: "#fff", fontWeight: 600, padding: "8px 16px", borderRadius: "8px", fontSize: "0.85rem" }} onClick={handleProductExactPriceChange}>
                          ✓ Définir le prix exact
                        </button>
                      </div>
                      <small className="text-muted d-block mt-2">
                        Définissez directement le nouveau prix sans calcul de pourcentage
                        <br />
                        <span style={{ fontSize: "0.85rem", color: "#555" }}>⚠️ Saisir les centimes avec un point: ex. 10,5 pour 10,500 DT</span>
                      </small>
                    </div>
                  )}
                </div>
              )}

              {/* ── Category / subcategory badges ── */}
              <div style={{ lineHeight: "1.6", marginTop: "1rem" }}>
                {product.category && (
                  <div className="mb-2">
                    {(() => {
                      let cats = [];
                      try { cats = JSON.parse(product.category); } catch { cats = [product.category]; }
                      return cats.map((cat, idx) => (
                        <span key={idx} style={{ display: "inline-block", backgroundColor: "#ff41b4", color: "#fff", padding: "4px 10px", borderRadius: "12px", fontSize: "0.85rem", marginRight: "6px", marginBottom: "4px" }}>
                          {cat}
                        </span>
                      ));
                    })()}
                  </div>
                )}
                {product.subcategory && (
                  <div className="mb-2">
                    {(() => {
                      let subs = [];
                      try { subs = JSON.parse(product.subcategory); } catch { subs = [product.subcategory]; }
                      return subs.map((sub, idx) => (
                        <span key={idx} style={{ display: "inline-block", backgroundColor: "#ffc107", color: "#333", padding: "4px 10px", borderRadius: "12px", fontSize: "0.85rem", marginRight: "6px", marginBottom: "4px" }}>
                          {sub}
                        </span>
                      ));
                    })()}
                  </div>
                )}

                {/* Info box */}
                {(product.weight || product.brand || product.price_range) && (
                  <div className="pd-info-box mb-2">
                    {product.weight && (
                      <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                        <span>⚖️</span>
                        <span style={{ fontSize: "0.9rem", color: "#333" }}><strong>Poids:</strong> {product.weight}</span>
                      </div>
                    )}
                    {product.brand && (
                      <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                        <span>🏷️</span>
                        <span style={{ fontSize: "0.9rem", color: "#333" }}><strong>Marque:</strong> {product.brand}</span>
                      </div>
                    )}
                  {product.price_range && (
  <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
    <span>💰</span>
    <span style={{ fontSize: "0.9rem", color: "#ff4cbb" }}>
      <strong style={{ fontWeight: 700 }}>Prix:</strong>{" "}
      {parseFloat(String(product.price_range).replace(",", "."))
        .toLocaleString("fr-FR", { maximumFractionDigits: 3 })} DT
    </span>
  </div>
)}
                  </div>
                )}

                {product.description && (
                  <p style={{ marginTop: "0.75rem", color: "#444", fontStyle: "italic", backgroundColor: "#fff0f6", padding: "0.5rem 0.75rem", borderRadius: "6px" }}>
                    <strong>Description:</strong> {product.description}
                  </p>
                )}
              </div>

              {/* ── Variations toggle ── */}
              <button
                className="btn mb-3"
                style={{ backgroundColor: "#ff41b4", color: "white", marginTop: "10px" }}
                onClick={() => setShowVariationsModal(!showVariationsModal)}
              >
                {showVariationsModal ? "Masquer les variations" : "Gérer les variations"}
              </button>

              {showVariationsModal && (
                <>
                  <ul className="list-group mb-4">
                    {variations.map((variation) => (
                      <li key={variation.id} className="list-group-item pd-variation-item">
                        <div className="pd-variation-inner">
                          {/* Left: info */}
                          <div style={{ flex: 1, minWidth: 0 }}>
                            {variation.image && (
                              <img
                                src={variation.image}
                                alt={variation.variation_name}
                                style={{ width: "60px", height: "60px", objectFit: "cover", borderRadius: "8px", marginRight: "10px", float: "left" }}
                              />
                            )}
                            <strong>{variation.variation_name}</strong> – {variation.weight}
                            <div style={{ clear: "both" }} />
                            <div>
                              Prix:{" "}
                              {variation.promo && variation.old_price && (
                                <span style={{ textDecoration: "line-through", color: "#999", marginRight: "6px" }}>
                                  {formatPrice(variation.old_price)} DT
                                </span>
                              )}
                              <span style={{ color: variation.promo ? "#ff41b4" : "inherit", fontWeight: variation.promo ? "bold" : "normal" }}>
                                {formatPrice(variation.price)} DT
                              </span>
                              {variation.promo && variation.promo_type === "percentage" && (
                                <span style={{ backgroundColor: "#ff41b4", color: "white", padding: "2px 6px", borderRadius: "4px", fontSize: "0.75rem", marginLeft: "8px" }}>
                                  -{variation.promo_percentage || 0}%
                                </span>
                              )}
                              {variation.promo && variation.promo_type === "exact" && (
                                <span style={{ backgroundColor: "#28a745", color: "white", padding: "2px 6px", borderRadius: "4px", fontSize: "0.75rem", marginLeft: "8px" }}>
                                  Prix Promo
                                </span>
                              )}
                            </div>
                          </div>

                          {/* Right: action buttons */}
                          <div style={{ display: "flex", flexDirection: "column", gap: "6px", flexShrink: 0 }}>
                            <div className="pd-variation-btns">
                              <button
                                className="btn btn-sm"
                                style={{ backgroundColor: variation.promo ? "green" : "red", color: "white" }}
                                onClick={() => handleToggleVariationPromo(variation)}
                                disabled={updatingVariationPromo}
                              >
                                {variation.promo ? "Retirer Promo" : "Activer Promo"}
                              </button>
                              {variation.promo && (
                                <>
                                  <button
                                    className="btn btn-sm"
                                    style={{ backgroundColor: variation.promo_type === "percentage" ? "#007bff" : "#6c757d", color: "white" }}
                                    onClick={() => openPromoPopup(variation, "percentage")}
                                  >
                                    % {variation.promo_type === "percentage" ? "✓" : ""}
                                  </button>
                                  <button
                                    className="btn btn-sm"
                                    style={{ backgroundColor: variation.promo_type === "exact" ? "#28a745" : "#6c757d", color: "white" }}
                                    onClick={() => openPromoPopup(variation, "exact")}
                                  >
                                    💰 {variation.promo_type === "exact" ? "✓" : ""}
                                  </button>
                                </>
                              )}
                            </div>
                            <div className="pd-variation-btns">
                              <button
                                className="btn btn-sm"
                                style={{ backgroundColor: variation.available ? "green" : "red", color: "white" }}
                                onClick={() => handleToggleAvailability(variation)}
                              >
                                {variation.available ? "Disponible" : "Indisponible"}
                              </button>
                              <button
                                className="btn btn-sm"
                                style={{ backgroundColor: "gray", color: "white" }}
                                onClick={() => handleEditClick(variation)}
                              >
                                ✏️
                              </button>
                              <button
                                className="btn btn-sm"
                                style={{ backgroundColor: "#ff41b4", color: "white" }}
                                onClick={() => handleDeleteVariation(variation)}
                              >
                                🗑️
                              </button>
                            </div>
                          </div>
                        </div>
                      </li>
                    ))}
                  </ul>

                  <button
                    className="btn"
                    style={{ backgroundColor: "gray", color: "white" }}
                    onClick={() => {
                      setEditingVariation(null);
                      setVariationForm({ name: "", price: "", weight: "", old_price: "", composition: "", analysis: "", ingredients: "", antioxidants: "", energy: "", image: "" });
                      setShowFormModal(true);
                    }}
                  >
                    + Ajouter une variation
                  </button>
                </>
              )}

              <p className="text-muted mt-3">
                <small>Créé le: {new Date(product.created_at).toLocaleDateString()}</small>
              </p>

              {/* ── Action bar ── */}
              <div className="pd-action-bar">
                <Link
                  to="/admin/products"
                  className="pd-pill-btn"
                  style={{ textDecoration: "none" }}
                >
                  Retour <img src={pawPrint} alt="Retour" style={{ width: "20px" }} />
                </Link>

                <div className="pd-action-right">
                  <button
                    className="pd-pill-btn"
                    onClick={handleTogglePromo}
                    disabled={updatingPromo}
                  >
                    {updatingPromo ? "Mise à jour..." : product.promo ? "Retirer Promo" : "Activer Promo"}
                    <img src={pawPrint} alt="Promo" style={{ width: "20px" }} />
                  </button>
                  <button
                    className="pd-pill-btn"
                    onClick={handleDelete}
                    disabled={deleting}
                  >
                    {deleting ? "Suppression..." : "Supprimer"}
                    <img src={pawPrint} alt="Supprimer" style={{ width: "20px" }} />
                  </button>
                </div>
              </div>
            </div>
          </div>

          {/* ── Add / edit variation modal ── */}
          <Modal show={showFormModal} onHide={() => setShowFormModal(false)}>
            <Modal.Header>
              <Modal.Title>{editingVariation ? "Modifier une variation" : "Ajouter une variation"}</Modal.Title>
              <button
                type="button"
                className="btn btn-sm"
                style={{ background: "none", border: "none", fontSize: "1.5rem", lineHeight: "1", color: "#000" }}
                aria-label="Fermer"
                onClick={() => setShowFormModal(false)}
              >
                ×
              </button>
            </Modal.Header>
            <Modal.Body>
              <Form>
                {[
                  { label: "Nom de variation", key: "name", type: "text" },
                  { label: "Poids", key: "weight", type: "text" },
                  { label: "Prix", key: "price", type: "text", hint: "⚠️ Saisir les centimes avec un point: ex. 10,5 pour 10,500 DT" },
                  { label: "Ancien prix", key: "old_price", type: "text", hint: "⚠️ Saisir les centimes avec un point: ex. 10,5 pour 10,500 DT" },
                ].map(({ label, key, type, hint }) => (
                  <Form.Group className="mb-3" key={key}>
                    <Form.Label>{label}</Form.Label>
                    <Form.Control
                      type={type}
                      inputMode={key === "price" || key === "old_price" ? "decimal" : "text"}
                      value={variationForm[key]}
                      onChange={(e) => {
                        let val = e.target.value;
                        if (key === "price" || key === "old_price") {
                          // Accepter virgule et point, normaliser en virgule pour l'affichage
                          val = val.replace(".", ",");
                          // Ne garder qu'une seule virgule
                          const parts = val.split(",");
                          if (parts.length > 2) val = parts[0] + "," + parts.slice(1).join("");
                        }
                        setVariationForm({ ...variationForm, [key]: val });
                      }}
                    />
                    {hint && <p style={{ fontSize: "0.85rem", color: "#555", marginTop: "4px" }}>{hint}</p>}
                  </Form.Group>
                ))}

                {[
                  { label: "Composition", key: "composition" },
                  { label: "Analyse", key: "analysis" },
                  { label: "Ingrédients", key: "ingredients" },
                  { label: "Antioxydants", key: "antioxidants" },
                  { label: "Énergie", key: "energy" },
                ].map(({ label, key }) => (
                  <Form.Group className="mb-3" key={key}>
                    <Form.Label>{label}</Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={2}
                      value={variationForm[key]}
                      onChange={(e) => setVariationForm({ ...variationForm, [key]: e.target.value })}
                    />
                  </Form.Group>
                ))}

                <Form.Group className="mb-3">
                  <Form.Label>Image de variation</Form.Label>
                  <Form.Control type="file" accept="image/*" onChange={handleImageUpload} />
                  {variationForm.image && (
                    <img src={variationForm.image} alt="Preview" style={{ marginTop: 10, maxHeight: 100, borderRadius: 8 }} />
                  )}
                </Form.Group>
              </Form>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={() => setShowFormModal(false)}>Annuler</Button>
              <Button
                variant="primary"
                style={{ backgroundColor: "#ff41b4", borderColor: "#ff41b4" }}
                onClick={handleAddOrUpdateVariation}
                disabled={uploading}
              >
                {editingVariation ? "Modifier" : "Ajouter"}
              </Button>
            </Modal.Footer>
          </Modal>
        </div>
      </div>

      {/* ── Promo popup ── */}
      {showPromoPopup && (
        <div className="pd-popup-overlay">
          <div className="pd-popup-box">
            <h5>{currentPromoType === "percentage" ? "Pourcentage de la promo" : "Prix exact de la promo"}</h5>
            <input
              type="text" inputMode="decimal"
              value={promoInputValue}
              onChange={(e) => setPromoInputValue(e.target.value)}
              style={{ width: "100%", padding: "8px", margin: "10px 0", borderRadius: "6px", border: "1px solid #ccc" }}
              min="0"
              max={currentPromoType === "percentage" ? 100 : undefined}
            />
            <div style={{ display: "flex", justifyContent: "space-between", marginTop: "10px" }}>
              <button
                onClick={() => setShowPromoPopup(false)}
                style={{ padding: "6px 16px", borderRadius: "6px", background: "#ccc", color: "#000", border: "none" }}
              >
                Annuler
              </button>
              <button
                onClick={submitPromoPopup}
                style={{ padding: "6px 16px", borderRadius: "6px", background: "#28a745", color: "#fff", border: "none" }}
              >
                Valider
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
export default ProductDetails;
